import { render } from "./ConfirmRegistration.view.vue?vue&type=template&id=5fbf48f0"
import script from "./ConfirmRegistration.view.vue?vue&type=script&lang=js"
export * from "./ConfirmRegistration.view.vue?vue&type=script&lang=js"

import "./ConfirmRegistration.view.vue?vue&type=style&index=0&id=5fbf48f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__